<template>
	<section class="job-overview-milestones">
			<template v-for="item in milestones">
				<milestone
					v-if="setVisibility(item)"
					:key="generateUniqueHash(item)"
					:editable="checkEditableOverride(item.editable)"
					:date="getDateData(item)" 
					:label="item.label"
					:prop="item.prop"
					:approved="isJobApproved"
					:alert="checkLate(item.prop)"
					@input="emitData($event)"/>	
			</template>
	</section>
</template>


<script>
	import { mapState, mapActions } from 'vuex'

	import Milestone from '@/components/ui/Jobs/Job_Overview_Milestone_Item.vue'

	export default {
		name: 'job-overview-milestones',

		components: {
			'milestone' : Milestone
		},
		
		props: {
			milestones: {
				type: Array,
				required: true
			},
			type: {
				type: String,
				required: true
			},
			canEdit: {
				type: Boolean,
				required: false,
				default: null
			},
			editableOverride: {
				type: Boolean,
				required: false,
				default: false
			},
			showOffset: {
				type: Boolean,
				required: false,
				default: false
			}
		},

		computed:{
			...mapState({
				job: state => state.jobs.job
			}),

			getDateData() {
				return item => {
					if (item.label !== 'Submit' && (this.showOffset || !this.job.state || !this.isJobApproved)) {
						return { cache: Date.now(), type:'offset', data:item.offset }
					}
					return { cache: Date.now(), type:'date', data:item.data }
				}
			},

			checkEditableOverride() {
				return itemEditable => {
					if (!this.isJobApproved) return false
					if (!this.canEdit) return this.canEdit
					return this.editableOverride ? false : itemEditable
				}
			},

			setVisibility() {
				return item => {
					return (item.data || item.label === 'Approval') ? true : false
				}
			},

			isJobApproved() {
				return (this.job.state === 'exec_approved' || this.job.state === 'active') ? true : false
			},

			checkLate() {
				return prop => {
					return (prop && prop === "date_first_comp" && this.job.is_late) ? true : false
				}
			}	
		},
		
		methods: {
			emitData(val) {
				if (this.type === 'create') {
					this.$store.dispatch('VUEX_JOB_CREATE_UPDATE_PROP', val )
				} else {
					this.$store.dispatch('VUEX_JOB_UPDATE_PROP', val )
				}
			}
		}
	}
</script>